import AuthorizeService from '@/v2/services/authorize';

export class ReportsModulePolicy {
	static canUseProductsAlertsReport() {
		return AuthorizeService.can('reports.orders.products_alerts');
	}
	static canUseReturnedOrdersReport() {
		return AuthorizeService.can('reports.orders.return_orders');
	}
	static canUseVariantPriceReport() {
		return AuthorizeService.can('reports.orders.variant_price');
	}
	static canUseVariantSalesReport() {
		return AuthorizeService.can('reports.orders.variant_sales');
	}
	static canUseProductsReport() {
		return AuthorizeService.can('reports.products.all');
	}
	static canUseProductsGeneralOrdersReport() {
		return AuthorizeService.can('reports.products.general_orders');
	}
	static canUseProductsGeneralOrdersDetailedReport() {
		return AuthorizeService.can('reports.products.general_orders_detailed');
	}
	static canUseProductsLinkedVariantsReport() {
		return AuthorizeService.can('reports.products.linked_variants');
	}
	static canUseProductsSalesReport() {
		return AuthorizeService.can('reports.products.sales');
	}
	static canUseProductsAnyReport() {
		return AuthorizeService.can('reports.products.*');
	}
	static canUseTransactionsReport() {
		return AuthorizeService.can('reports.transactions');
	}
	static canUseTrendyolLogsReport() {
		return AuthorizeService.can('reports.trendyol.logs');
	}
	static canUsePricingLogReport() {
		return AuthorizeService.can('reports.products.pricing-logs')
	}
	static canUseActivityLogReport() {
		return AuthorizeService.can('reports.activity-logs')
	}
	static canUseProductOperationReport() {
		return AuthorizeService.can('reports.products.operations')
	}
	static canUseFbaInventoryReport() {
		return AuthorizeService.can('reports.amazon.fba_inventory');
	}
}
